import React, { useState, useEffect } from 'react'
import { Row, Col, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CachedIcon from '@mui/icons-material/Cached';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import RolePill from '../../../components/lists/rolePill';
import Loader from 'react-loaders';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';

//Redux
import { connect } from 'react-redux';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const getUser = functionsHttpsCallable('usuarios_obtenerDataUsuario');
const getRoles = functionsHttpsCallable('auth_listadoRoles');
const addRole = functionsHttpsCallable('usuarios_asignarRol');
const updateEmail = functionsHttpsCallable('usuarios_actualizarCorreo');
const deleteRol = functionsHttpsCallable('usuarios_eliminarRol');
const deleteUser = functionsHttpsCallable('usuarios_eliminarUsuario');

const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyUserID = (props) => {
    const [searchEmail, setSearchEmail] = useState('');
    const [email, setEmail] = useState('');
    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [showList, setShowList] = useState(false);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [roles, setRoles] = useState([]);

    const eliminarUsuario = async () => {
        setLoading(true)
        const body = {
            email: user.email,
            token: userData.token
        }
        const userDataReq = await deleteUser(body);
        if (userDataReq.data.status === 'USUARIO_ELIMINADO') {
            setLoading(false)
            props.toggle()
            props.toastSuccess('Usuario Eliminado')
        }
        else if (userDataReq.data.status === 'USUARIO_NO_EXISTE') {
            props.toastError('Usuario no encontrado')
        }
        else {
            props.toastError('Hubo un error')
        }
    }

    const getUserDataByEmail = async () => {
        setLoading(true)
        const body = {
            username: searchEmail,
            token: userData.token
        }
        const userDataReq = await getUser(body);
        const roleDataReq = await getRoles(body);
        if (userDataReq.data.status === 'USUARIO_OBTENIDO') {
            setUser(userDataReq.data.data)
            setEmail(userDataReq.data.data.email)
            props.toastSuccess('usuario encontrado')
        }
        else if (userDataReq.data.status === 'USUARIO_NO_EXISTE') {
            setUser({})
            props.toastError('Usuario no encontrado')
        }
        else {
            setUser({})
            props.toastError('Hubo un error')
        }

        if (roleDataReq.data.status === 'CONSULTA_EXITOSA') {
            setRoles(getRolesList(userDataReq.data.data.roles, roleDataReq.data.data))
            props.toastSuccess('Roles obtenidos')
        }
        else {
            setRoles([])
            props.toastError('Hubo un error al obtener listado de roles')
        }
        setLoading(false);
    }

    const handleOnClickAddRole = () => {
        setShowList(!showList)
    }

    const getRolesList = (userRoles, roles) => {
        if (userRoles !== undefined) {
            const tempRoles = roles.filter(o => !userRoles.some(i => i.id === o.id))
            return tempRoles
        }
        else return []
    }

    const handleAddRole = async (rol) => {
        setLoading(true)
        const newRol = roles.filter((role) => (role.name === rol))
        const body = {
            userId: user.user_id,
            rol: newRol[0].id,
            token: userData.token,
            correo: user.email,
            id: user.username,
            cod_empr: userData.codigoEmpresa
        }
        const addRoleReq = await addRole(body);
        if (addRoleReq.data.status === 'ROL_ASIGNADO') {
            await getUserDataByEmail()
            props.toastSuccess('Rol asignado')
        }
        else {
            props.toastError('Hubo un error al asignar el rol')
        }
        setLoading(false)
        setShowList(false)
    }

    const handleDeleteRole = async (rol) => {
        const body = {
            userId: user.user_id,
            rol: rol,
            token: userData.token,
            id: user.username,
            cod_empr: userData.codigoEmpresa
        }
        const addRoleReq = await deleteRol(body);
        if (addRoleReq.data.status === 'ROL_ELIMINADO') {
            await getUserDataByEmail()
            props.toastSuccess('Rol eliminado')
        }
        else {
            props.toastError('Hubo un error al eliminar el rol')
        }
        setShowList(false)
    }

    const handleUpdateEmail = async () => {
        setLoading(true)
        const body = {
            token: userData.token,
            email: user.email,
            newEmail: email
        }
        const updateEmailReq = await updateEmail(body);
        if (updateEmailReq.data.status === 'USUARIO_ACTUALIZADO') {
            const tempUser = { ...user }
            tempUser.email = email
            setUser({ ...tempUser })
            props.toastSuccess('Correo actualizado')
        }
        else {
            props.toastError('Hubo un error al actualizar el correo')
        }
        setLoading(false)
    }

    return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='10' md='10' xs="10">
                        <TextField
                            required
                            key={`key_mail`}
                            id={`input_mail`}
                            fullWidth
                            label='Cédula'
                            margin="normal"
                            onChange={(e) => { setSearchEmail(e.target.value) }}
                        />
                    </Col>
                </Row>
                <div className='user-by-email-2'></div>
                {loading ? <Loader type="line-scale-party" /> : Object.keys(user).length > 0 ?
                    <div className='user-by-email'>
                        <Row className='user-by-email'>
                            <Col lg='6' md='6' xs="6">
                                <TextField
                                    required
                                    key={`key_mail`}
                                    id={`input_mail`}
                                    fullWidth
                                    label='Cédula'
                                    defaultValue={user.username}
                                    margin="normal"
                                    disabled
                                />
                            </Col>
                            <Col lg='6' md='6' xs="6">
                                <TextField
                                    required
                                    key={`key_mail`}
                                    id={`input_mail`}
                                    fullWidth
                                    label='Correo'
                                    defaultValue={user.email}
                                    margin="normal"
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {email === user.email ? <IconButton disabled>
                                                    <CheckCircleOutlineIcon color="success" />
                                                </IconButton> :
                                                    <IconButton onClick={() => { handleUpdateEmail() }}>
                                                        <CachedIcon color="primary" />
                                                    </IconButton>}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="6">
                                <TextField
                                    required
                                    key={`key_name`}
                                    id={`input_name`}
                                    fullWidth
                                    label='Nombre'
                                    defaultValue={user.name}
                                    margin="normal"
                                />
                            </Col>
                            <Col lg='6' md='6' xs="6">
                                <Label for="rolesLabel">Roles</Label>
                                <RolePill
                                    roles={user.roles}
                                    listOfRoles={roles}
                                    onClick={() => handleOnClickAddRole()}
                                    addRole={(e) => handleAddRole(e)}
                                    deleteRol={(e) => handleDeleteRole(e)}
                                    showList={showList}
                                // setShowList={(e) => setShowList(e)}
                                />
                            </Col>
                        </Row>
                    </div> : <p>No se encontro el usuario</p>}
                <Col lg='12' md='12' xs="12" className='user-create-button'>
                    <CrearUsuario
                        onClick={() => eliminarUsuario()}
                        disabled={!(user.email !== undefined && user.email !== '')}
                        color='error'
                        tittle='Eliminar'
                    />
                    <CrearUsuario
                        onClick={() => { getUserDataByEmail() }} 
                        disabled={false}
                        tittle='Buscar'
                    />
                </Col>
            </div>
        </div >
    );
}
export default connect(mapStateToProps)(BodyUserID);